export default "__VITE_ASSET__CjmyPLpF__"